export function initShare() {
    function showFeedback(el, message) {
        const original = el.textContent;
        el.textContent = message;
        setTimeout(() => { el.textContent = original; }, 1800);
    }

    document.querySelectorAll('[data-share]').forEach((el) => {
        el.addEventListener('click', async (e) => {
            e.preventDefault();
            const title = document.title;
            const url = window.location.href;

            if (navigator.share) {
                try {
                    await navigator.share({ title, url });
                } catch (err) {
                    if (err.name !== 'AbortError') { /* swallow */ }
                }
            } else {
                try {
                    await navigator.clipboard.writeText(url);
                    showFeedback(el, '✓ Copied');
                } catch (err) {
                    /* swallow */
                }
            }
        });
    });

    document.querySelectorAll('[data-share-copy]').forEach((el) => {
        el.addEventListener('click', async (e) => {
            e.preventDefault();
            try {
                await navigator.clipboard.writeText(window.location.href);
                showFeedback(el, '✓ Copied');
            } catch (err) {
                /* swallow */
            }
        });
    });

    document.querySelectorAll('[data-share-mailto]').forEach((el) => {
        const subject = encodeURIComponent(document.title);
        const body = encodeURIComponent(window.location.href);
        el.href = `mailto:?subject=${subject}&body=${body}`;
    });

    document.querySelectorAll('[data-back-to-top]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
}
